export default __webpack_public_path__ + "static/media/map.be74191a.png";